import React from "react";
import { ModalType } from "../types/ModalTypes";
import SettingsModalContent from "../ui/SettingsModalContent";
import ProfileModalContent from "../ui/ProfileModalContent";
import AboutAppModalContent from "../ui/AboutAppModalContent";

interface ModalContentProps {
  modalType: ModalType;
  onNavigateToProfile: () => void;
  onNavigateToAbout: () => void;
  onBackToSettings: () => void;
  navigateToAstrologChanel: () => void;
  navigateToDeveloperChanel: () => void;
  isPushNotificationEnabled: boolean;
  handleEnableNotifications: () => void;
  logout: () => void;
  userInfo: any;
  subscription: any;
  onDelete: () => void;
  aboutText: string;
  navigateToSubscription: () => void;
}

export const ModalContent: React.FC<ModalContentProps> = ({ 
  modalType, 
  onNavigateToProfile, 
  onNavigateToAbout, 
  onBackToSettings,
  navigateToAstrologChanel,
  navigateToDeveloperChanel,
  isPushNotificationEnabled,
  handleEnableNotifications,
  logout,
  userInfo,
  subscription,
  onDelete,
  aboutText,
  navigateToSubscription
}) => {
  const modalComponents = {
    [ModalType.Settings]: (
      <SettingsModalContent
        navigateToAstrologChanel={navigateToAstrologChanel}
        navigateToDeveloperChanel={navigateToDeveloperChanel}
        navigateToProfile={onNavigateToProfile}
        onAbout={onNavigateToAbout}
        isPushNotificationEnabled={isPushNotificationEnabled}
        handleEnableNotifications={handleEnableNotifications}
      />
    ),
    [ModalType.Profile]: (
      <ProfileModalContent
        onLogout={logout}
        userInfo={userInfo}
        subscription={subscription}
        onDelete={onDelete}
        onBack={onBackToSettings}
        navigateToSubscription={navigateToSubscription}
      />
    ),
    [ModalType.About]: (
      <AboutAppModalContent onBack={onBackToSettings} aboutText={aboutText} />
    )
  };

  return modalComponents[modalType] || null;
}; 